import type {
  GetAllArticlesPayload,
  GetAllArticlesResponse,
  GetArticleBySlugPayload,
  GetAuthorBySlugPayload,
  GetAuthorBySlugResponse,
} from "~/repository/articles.types";
import type { Article } from "~/types";
import { map } from "lodash-es";
import type { PublishSearchTrackPayload } from "~/repository/search.types";

export async function getAllArticles(
  payload: GetAllArticlesPayload,
): Promise<GetAllArticlesResponse> {
  const { $api } = useNuxtApp();
  const { pagination, query } = payload;

  if (query) {
    const searchRes: any = await $api("v4")(
      `/news/search?query=${query || ""}&sort[0]=published_at&sortby[0]=desc&showonlypublished=true&pagination[pageOffset]=${pagination.pageOffset}&pagination[pageSize]=${pagination.pageSize}`,
    );
    return {
      data: map(searchRes.items, (el) => ({
        ...el,
        media: { url: el.images },
        published_at: el.date,
      })),
    };
  }
  return await $api("v4")(
    `/news?sort[0]=published_at&sortby[0]=desc&showonlypublished=true&pagination[pageOffset]=${pagination.pageOffset}&pagination[pageSize]=${pagination.pageSize}`,
  );
}

export async function getArticleBySlug(
  payload: GetArticleBySlugPayload,
): Promise<Article> {
  const { $api } = useNuxtApp();
  return await $api("v4")(`/news/${payload.slug}`);
}

export async function getPreviewArticleBySlug(
  payload: GetArticleBySlugPayload,
): Promise<Article> {
  const { $api } = useNuxtApp();
  return await $api("v4")(`/news/preview/${payload.slug}`);
}

export async function getAuthorBySlug(
  payload: GetAuthorBySlugPayload,
): Promise<GetAuthorBySlugResponse> {
  const { $api } = useNuxtApp();
  return await $api("v4")(`/news/author/${payload.slug}`);
}

export async function getNewsSearchAutocomplete(payload: {
  query: string;
}): Promise<string[]> {
  const { $api } = useNuxtApp();
  const { query } = payload;
  return await $api("v4")(
    `/news/search/autocomplete?query=${query}&maxResults=10`,
  );
}

export async function publishNewsSearchTrack(
  payload: PublishSearchTrackPayload,
) {
  const { $api } = useNuxtApp();
  return await $api("v4")(`news/search/track`, {
    method: "POST",
    body: payload,
  });
}
